import { useEffect, useState } from "react";
import { Checkbox, Popup } from "antd-mobile";
import styled from "styled-components";

const Title = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  padding: 20px 16px 12px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-top: 1px solid rgb(200, 200, 200);
  cursor: pointer;
`;

const Label = styled.div`
  flex: 1;
  font-size: 16px;
`;

const Close = styled.div`
  position: absolute;
  right: 16px;
  top: 14px;
  color: rgb(200, 200, 200);
  cursor: pointer;
`;

const OPTIONS = [
  { value: 1, label: "全部" },
  { value: 2, label: "100-1千" },
  { value: 3, label: "1千-3千" },
  { value: 4, label: "3千-8千" },
  { value: 5, label: "8千-1万2" },
  { value: 6, label: "1万2以上" },
];

type Props = {
  visible: boolean;
  setVisible: (v: boolean) => void;
  value?: number;
  onSelect: (v: number) => void;
};

const QuantityFilterModal = ({ visible, setVisible, value, onSelect }: Props) => {
  const [inner, setInner] = useState<number | undefined>(value);

  useEffect(() => {
    if (visible) setInner(value);
  }, [value, visible]);

  return (
    <Popup
      visible={visible}
      onMaskClick={() => setVisible(false)}
      bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, paddingBottom: 40 }}
    >
      <div style={{ position: "relative" }}>
        <Close onClick={() => setVisible(false)}>关闭</Close>
        <Title>数量筛选范围</Title>
        {OPTIONS.map((opt) => (
          <Row
            key={opt.value}
            onClick={() => {
              setInner(opt.value);
              onSelect(opt.value);
              setVisible(false);
            }}
          >
            <Label>{opt.label}</Label>
            <Checkbox checked={inner === opt.value} />
          </Row>
        ))}
      </div>
    </Popup>
  );
};

export default QuantityFilterModal;
